import { useAuth } from "context/AuthContext"
import { Redirect, Route } from "react-router-dom"

const PublicRoute = ({children, ...rest}) =>{
    const { authorized, loading } = useAuth();
    return <Route {...rest} render={
        ({location})=>
            loading ? null :
            !authorized ? (children) :
            ( <Redirect to={{ pathname:"/dashboard", state: {from: location} }} />)
        }
    />
}

export default PublicRoute